import { type ICondoFullMfhCalendarEvent, condoEventToFullCalendar, constructRequestObj } from '@/components/mfh/calendar/common';
import { useLoading } from '@/hooks';
import { store } from '@/store';
import type { IMFHCalendarEvent, IMFHCalendarEventCreateParams, IMFHCalendarEventSearchParams } from '@condo/domain';

export const useMFHCalendarEvents = () => {
    const { toggle } = useLoading();

    const getCalendarEvents = async (props: IMFHCalendarEventSearchParams) => {
        const events = await store.dispatch('mfhCalendarEvents/getCalendarEvents', {
            calendarType: props.calendarType,
            mfhId: props.mfhId,
            userId: props.userId,
        });
        if (events) {
            return events.map(ev => condoEventToFullCalendar(ev, props.mfhId));
        }

        return [];
    };

    const saveCalendarEvent = async (data: ICondoFullMfhCalendarEvent, mfhId: number, condoUuid: string): Promise<ICondoFullMfhCalendarEvent> => {
        toggle(true);
        const newEvent = !!data.calendarEventId;
        const eventRequest = constructRequestObj(data, mfhId);

        const prefix = condoUuid || mfhId;

        let calendarEvent;

        if (eventRequest.calendarEventId) {
            calendarEvent = await store.dispatch('mfhCalendarEvents/updateCalendarEvent', eventRequest as unknown as IMFHCalendarEvent);
        } else {
            calendarEvent = await store.dispatch('mfhCalendarEvents/createCalendarEvent', eventRequest as unknown as IMFHCalendarEventCreateParams);
        }

        toggle(false);
        return condoEventToFullCalendar(calendarEvent, mfhId);
    };

    const deleteCalendarEvent = async id => {
        toggle(true);
        return store.dispatch('mfhCalendarEvents/deleteCalendarEvent', id).finally(() => toggle(false));
    };

    return {
        deleteCalendarEvent,
        getCalendarEvents,
        saveCalendarEvent,
    };
};
